var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnlockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0.499512C12.4852 0.499516 14.4999 2.51435 14.5 4.99951H13C12.9999 3.34277 11.6568 1.99952 10 1.99951C8.34323 1.99951 7.00013 3.34277 7 4.99951V7.49951C7 7.55343 6.99323 7.60604 6.98242 7.65674H16.25V17.0317H3.75V7.65674H5.51758C5.50676 7.60604 5.5 7.55343 5.5 7.49951V4.99951C5.50013 2.51434 7.5148 0.499512 10 0.499512ZM10 9.21924C9.24061 9.21924 8.625 9.83485 8.625 10.5942C8.625 11.1282 8.93032 11.5891 9.375 11.8169V13.9067C9.375 14.2519 9.65483 14.5317 10 14.5317C10.3452 14.5317 10.625 14.2519 10.625 13.9067V11.8169C11.0697 11.5891 11.375 11.1282 11.375 10.5942C11.375 9.83485 10.7594 9.21924 10 9.21924Z",
    fill: "#1A1B1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlockIcon);
export default __webpack_public_path__ + "static/media/unlock-icon.282dba8d42fc65086d6b06d2d0702eb7.svg";
export { ForwardRef as ReactComponent };